<template>
  <v-card v-if="!free" fill-height style="height:100%;width:100%;" @click="showDialog">
    <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">
      <div style="width: 100%">{{ title }}</div>
      <div
          v-if="load"
          style="width: 50%; justify-content: end; display: flex; align-items: center;"
      >
        <div v-if="legened== 'engineState'" style="text-align: right; font-size: 14px; font-weight: initial;">
          <ul style="display: inline-flex; list-style: none; margin: 0; padding: 0; margin-left: 5px;">
            <li :style="'border-left: 3px solid ' + engineOff + '; padding-left: 5px;'">Engine OFF</li>
            <li :style="'border-left: 3px solid ' + engineOn + '; padding-left: 5px; margin-left: 5px;'">Engine ON</li>
          </ul>
        </div>

        <span
            v-if="maximizeCallback"
            @click="(e) => {e.preventDefault(); maximizeCallback(chartOptions)}"
            class="maximize-icon"
        >
            <font-awesome-icon icon="maximize" style="color:rgb(51,82,128);"/>
          </span>
      </div>
    </v-card-title>
    <v-card-actions ref="chartContainer" fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
      <highcharts v-if="load" style="height:100%; width:100%;" :class="repClass" :options="chartOptions"/>
    </v-card-actions>
  </v-card>
  <container v-else style="height:100%; width:100%;">
    <highcharts v-if="load" style="height:100%; width:100%;" :class="repClass" :options="chartOptions"/>
  </container>
</template>

<script>

import {Chart} from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'

More(Highcharts)

export default {
  name: "TimelineChart",
  components: {
    highcharts: Chart
  },
  props: {
    chartOptions: Object,
    active: Boolean,
    title: String,
    repClass: String,
    engineOff: String,
    engineOn: String,
    legened: String,
    free: Boolean,
    maximizeCallback: Function
  },
  data: function () {
    return {
      load: false
    }
  },
  methods: {
    onResize() {
      setTimeout(() => {
        if (typeof this.chartOptions.chart != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
          this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        }

        this.load = true;
      });
    },
    loaded() {
      if (this.active) {
        setTimeout(() => {
          if (typeof this.chartOptions.chart != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
            this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
          }

          this.load = true;
        });
      }
    }
  },
  created() {
    // this.popUpOptions = this.chartOptions;

  },
  mounted() {
    window.addEventListener('resize', this.onResize);

    this.loaded()
  },
  watch: {
    active: function () {
      this.loaded()
    },
    chartOptions: function () {
      setTimeout(() => {
        if (typeof this.$refs != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
          console.log('123456789');
          this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
        }

        this.load = true;
      });
    }
  }
}
</script>

<style scoped>
</style>
